module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }